import { HANDLE_USERS, RESET } from '../actions';

const initialState = {  
    users: [],
    userApiCalled: false,
    search: ""
};

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case HANDLE_USERS:
      console.log(action);
      return {
        ...state,
        ...action.data
      };
    case RESET :
      return initialState
    default:
      return state;
  } 
}
